import * as React from 'react'
import { SVGProps } from 'react'

const SvgBackNavArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#back-nav-arrow-icon_svg__a)" stroke="#fff" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M5 12l6 6M5 12l6-6" />
    </g>
    <defs>
      <clipPath id="back-nav-arrow-icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBackNavArrowIcon
